<template>
  <v-app-bar color="primary" dark flat class="modern-navbar">
    <v-row align="center" no-gutters class="w-100 navbar-row flex-row-reverse px-6">
      <v-col cols="auto">
        <span class="modern-title">{{ $t("appName") }}</span>
      </v-col>
      <v-spacer />
      <v-col cols="auto" class="toolbar-btns-col" style="display: flex; align-items: center;">
        <NavBarSettings
          :themeToggle="themeToggle"
          :isDark="isDark"
          :langToggle="langToggle"
          :languageOptions="languageOptions"
          :currentEnv="currentEnvironment"
          :isAdmin="isAdmin"
          @toggle-theme="$emit('toggle-theme', $event)"
          @set-locale="$emit('set-locale', $event)"
          @set-environment="setEnvironment"
          @logout="handleLogout"
        />
        <!-- Environment Status Chip -->
        <v-chip
          :color="currentEnvironment === 'PROD' ? 'success' : 'warning'"
          size="small"
          class="mr-4"
          variant="flat"
        >
          <v-tooltip :text="currentBaseUrl" location="bottom">
            <template #activator="{ props }">
              <div v-bind="props" class="d-flex align-center font-weight-bold">
                <v-icon
                  :icon="currentEnvironment === 'PROD' ? 'mdi-shield-check' : 'mdi-test-tube'"
                  size="small"
                  class="mr-1"
                ></v-icon>
                {{ currentEnvironment }}
              </div>
            </template>
          </v-tooltip>
        </v-chip>
        <v-chip :color="keepAliveStatusColor" size="small" class="mr-4">
          <v-tooltip
            :text="
              lastKeepAliveTime
                ? new Date(lastKeepAliveTime).toLocaleString(
                    $i18n.locale === 'he' ? 'he-IL' : 'en-US'
                  )
                : $t('capena.noKeepAlive')
            "
            location="bottom"
          >
            <template #activator="{ props }">
              <div v-bind="props" class="d-flex align-center">
                <v-icon
                  :icon="
                    keepAliveStatusColor === 'success'
                      ? 'mdi-clock-check'
                      : 'mdi-clock-alert'
                  "
                  size="small"
                  class="mr-1"
                ></v-icon>
                <span v-if="lastKeepAliveDisplay !== null">
                  {{ $t("capena.lastKeepAlive") }}:
                  {{ lastKeepAliveDisplay }}
                </span>
                <span v-else>
                  {{ $t("capena.noKeepAlive") }}
                </span>
              </div>
            </template>
          </v-tooltip>
        </v-chip>
        <v-chip
          :color="isCapenaConnected ? 'success' : 'error'"
          size="small"
          class="mr-4"
        >
          <v-tooltip :text="$t('capena.connection')" location="bottom">
            <template #activator="{ props }">
              <div v-bind="props" class="d-flex align-center">
                <v-icon
                  :icon="isCapenaConnected ? 'mdi-wifi' : 'mdi-wifi-off'"
                  size="small"
                  class="mr-1"
                ></v-icon>
                {{
                  isCapenaConnected
                    ? $t("capena.connected")
                    : $t("capena.disconnected")
                }}
              </div>
            </template>
          </v-tooltip>
        </v-chip>
      </v-col>
    </v-row>
  </v-app-bar>
</template>
<script>
import NavBarSettings from './NavBarSettings.vue';
import axios from 'axios';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'NavBar',
  components: { NavBarSettings },
  props: {
    themeToggle: String,
    isDark: Boolean,
    langToggle: String,
    languageOptions: Array,
    keepAliveStatusColor: String,
    lastKeepAliveTime: [String, Number, null],
    lastKeepAliveDisplay: [String, null],
    isCapenaConnected: Boolean
  },
  data() {
    return {
      currentEnvironment: 'PROD',
      currentBaseUrl: 'Loading...'
    };
  },
  computed: {
    ...mapGetters(['isAdmin'])
  },
  methods: {
    ...mapActions(['resetKeepAlive', 'logout']),
    async handleLogout() {
      await this.logout();
      this.$router.push({ name: 'Login' });
    },
    async fetchEnvironment() {
      try {
        const response = await axios.get('/api/environment');
        this.currentEnvironment = response.data.environment;
        // In a real app we might get the URL from the backend too, 
        // to be accurate. For now we infer or fetch if possible.
        // Let's assume the backend also returns the URL or we map it.
        // Actually, Controller only returns "environment". 
        // We can update controller to return URL or map it here.
        this.updateBaseUrlDisplay();
      } catch (error) {
        console.error("Failed to fetch environment", error);
      }
    },
    async setEnvironment(env) {
      if (env === this.currentEnvironment) return;
      try {
        await axios.post('/api/environment', { environment: env });
        this.currentEnvironment = env;
        this.updateBaseUrlDisplay();
        this.resetKeepAlive(); // Reset keepalive on successful switch
      } catch (error) {
        console.error("Failed to set environment", error);
      }
    },
    updateBaseUrlDisplay() {
      // Hardcoded mapping based on known backend config, 
      // ideally backend sends this in GET /api/environment
      if (this.currentEnvironment === 'PROD') {
        this.currentBaseUrl = 'https://prod.capena.idf.il';
      } else {
        this.currentBaseUrl = 'https://preprod.capena.idf.il'; // Default or from config
      }
    }
  },
  mounted() {
    this.fetchEnvironment();
  }
};
</script> 
<style scoped>
.modern-title {
  font-size: 140%;
  font-weight: 500;
}

@media (max-width: 768px) {
  .modern-title {
    font-size: 80%;
  }
}
</style>